import React, { useContext } from "react";
import FileUpload from "../Components/FileUpload";
import { FileUploadRecievedProps } from "../FileUploadTypes";
import { CheckResponsiveContext } from "../../../Context/CheckResponsiveContext";
import FileUploadMobileView from "../Components/FileUploadMobileView";

function FileUploadContainer({
  questionId,
  isPreview,
  surveyAnswersInfo,
  reducerState,
  dispatch,
  removeAttachedFile,
  surveyAnswers,
}: FileUploadRecievedProps) {
  const { isMobile } = useContext(CheckResponsiveContext);

  return (
    <>
      {isMobile ? (
        <FileUploadMobileView
          reducerState={reducerState}
          dispatch={dispatch}
          isPreview={isPreview}
          surveyAnswersInfo={surveyAnswersInfo}
          questionId={questionId}
          removeAttachedFile={removeAttachedFile}
          surveyAnswers={surveyAnswers}
        />
      ) : (
        <FileUpload
          reducerState={reducerState}
          dispatch={dispatch}
          isPreview={isPreview}
          surveyAnswersInfo={surveyAnswersInfo}
          questionId={questionId}
          removeAttachedFile={removeAttachedFile}
          surveyAnswers={surveyAnswers}
        />
      )}
    </>
  );
}

export default FileUploadContainer;
